import React from 'react';
import { getTranslationKeyWithInflection } from '../inflexion';
import { TRANSLATIONS_MATCH_PRODUCT_COUNT_REPLACEMENT } from '../constants';

const getMatchItemCountLabel = (translations, matchProductCount) => {
    const texts = translations[
        getTranslationKeyWithInflection('eshop.configurator.info.selection_result_count', matchProductCount)
    ].split(TRANSLATIONS_MATCH_PRODUCT_COUNT_REPLACEMENT);
    return (
        <>
            {texts[0]}
            <strong>{matchProductCount}</strong>
            {texts[1]}
        </>
    );
};

export const FiltrationBlock = ({
    name,
    options,
    activeFilters,
    toggleFilter,
    matchProductCount,
    getOptionCount,
    expanded,
    toggleExpanded,
    translations,
}) => (
    <div className="filtration-block">
        <div className="filtration-block__title">{name}</div>
        <a href="#" className="filtration-block__toggler" onClick={(e) => (e.preventDefault(), toggleExpanded())}>
            <span>{translations['eshop.configurator.action.show_filters']}</span>
            <img className="arrow-icon" src="../../../img/theme/icons/10-arr.green.svg" alt="green icon" />
        </a>
        {expanded ? (
            <div className="filtration-block__items-wrapper">
                {options.map((option) => (
                    <label className="custom-check-input" key={option.id}>
                        <input
                            id={`filter-${option.id}`}
                            type="checkbox"
                            className="custom-check-input__input"
                            value={activeFilters.includes((activeFilter) => activeFilter === option.id)}
                            onChange={() => toggleFilter(option.id)}
                        />
                        <span className="custom-check-input__checkmark custom-check-input__checkmark--checkbox" />
                        <span className="custom-check-input__label">
                            {option.label} ({getOptionCount(option.id)})
                        </span>
                    </label>
                ))}
            </div>
        ) : null}
        {activeFilters.length > 0 ? (
            <>
                <div className="divider" />
                <div className="filtration-block__match-items-count">
                    {getMatchItemCountLabel(translations, matchProductCount)}
                </div>
            </>
        ) : null}
    </div>
);
